export default __webpack_public_path__ + "static/media/explore.f11be700.svg";